import React from 'react'

const GoldenZigzag = ({ variant = 'default' }) => {
  return (
    <div className="w-full py-6 sm:py-8 flex items-center justify-center">
      <div className="flex-1 h-[2px] sm:h-[3px] bg-gradient-to-r from-transparent via-[#d4af37] to-transparent max-w-md" />
      <div className="mx-4 sm:mx-6">
        <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 rotate-45 border-[3px] border-[#d4af37] bg-white" />
      </div>
      <div className="flex-1 h-[2px] sm:h-[3px] bg-gradient-to-l from-transparent via-[#d4af37] to-transparent max-w-md" />
    </div>
  )
}

export default GoldenZigzag
